import { createSlice } from '@reduxjs/toolkit';
import { fetchBrowseNodeMaterials, fetchBrowseNodes, fetchImpactMetrics } from './browseNodeThunks';

const initialState = {
  data: [],
  metrics: [],
  materialsData: [],
  isFetching: false,
  error: null,
  isFetchingMaterialsData: false,
  errorMaterialsData: null,
  isFetchingRules: false,
  errorRules: null,
  obligationYears: [],
};

export const BrowseNodeSlice = createSlice({
  name: 'browseNodes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrowseNodeMaterials.pending, (state) => {
        state.isFetchingMaterialsData = true;
        state.errorMaterialsData = null;
      })
      .addCase(fetchBrowseNodeMaterials.fulfilled, (state, action) => {
        state.isFetchingMaterialsData = false;
        state.errorMaterialsData = null;
        state.materialsData = action.payload;
      })
      .addCase(fetchBrowseNodeMaterials.rejected, (state) => {
        state.isFetchingMaterialsData = false;
        state.errorMaterialsData = 500;
      })
      .addCase(fetchBrowseNodes.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchBrowseNodes.fulfilled, (state, action) => {
        state.isFetching = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(fetchBrowseNodes.rejected, (state) => {
        state.isFetching = false;
        state.error = 500;
      })
      .addCase(fetchImpactMetrics.fulfilled, (state, action) => {
        state.metrics = action.payload;
      });
  },
});

export default BrowseNodeSlice.reducer;
